import dayjs, { Dayjs } from 'dayjs'
import { getDefaultTimezone } from 'index'

export interface StartEndEvent {
  start: number
  end: number
}

/**
 * generates start/end time object based on time passed
 * @param time current time in seconds
 */
export function generateStartEndBasedOnTimeWithShift(
  time: number
): StartEndEvent {
  const eventStart =
    dayjs(time * 1000)
      .tz(getDefaultTimezone())
      .set('second', 0)
      .set('minute', 0)
      .set('millisecond', 0)

      .add(1, 'hour')
      .valueOf() / 1000
  const eventEnd = dayjs.unix(eventStart).add(1, 'hour').valueOf() / 1000
  return { start: eventStart, end: eventEnd }
}

export function generateStartEndBasedOnTime(
  time: number,
  vieType: string
): StartEndEvent {
  let dayjsTime = dayjs.unix(time).tz(getDefaultTimezone())
  if (vieType === 'dayGridMonth') {
    dayjsTime = dayjsTime.set('hour', 12)
  }
  const eventStart = dayjsTime.minute(0).valueOf() / 1000
  const eventEnd = dayjs.unix(eventStart).add(1, 'hour').valueOf() / 1000
  return { start: eventStart, end: eventEnd }
}

export function ms(t: number) {
  let year, month, day, hour, minute, second

  second = Math.floor(t / 1000)
  minute = Math.floor(second / 60)
  second = second % 60
  hour = Math.floor(minute / 60)
  minute = minute % 60
  day = Math.floor(hour / 24)
  hour = hour % 24
  month = Math.floor(day / 30)
  day = day % 30
  year = Math.floor(month / 12)
  month = month % 12

  return { year, month, day, hour, minute, second }
}

let cachedAMPM: boolean | null = null

export function isAMPM(): boolean {
  return true
  if (cachedAMPM !== null) {
    return cachedAMPM
  }

  const formatter = new Intl.DateTimeFormat([], { hour: 'numeric' })
  const parts = formatter.formatToParts(new Date())

  cachedAMPM = parts.some((part) => part.type === 'dayPeriod')

  return cachedAMPM
}

export const isDateBetween = (
  date: Dayjs,
  start: Dayjs,
  end: Dayjs
): boolean => {
  return (
    (date.isSame(start) || date.isAfter(start)) &&
    (date.isSame(end) || date.isBefore(end))
  )
}

/**
 * Gets the start of the week based on a specified first day of week
 * @param date The date to get start of week for
 * @param firstDayOfWeek 0 for Sunday, 1 for Monday, etc.
 */
export function getStartOfWeek(
  date: dayjs.Dayjs,
  firstDayOfWeek: number
): dayjs.Dayjs {
  // Calculate the weekday offset - the weekday plugin uses 0 as Monday by default
  // So we need to adjust our calculation based on the firstDayOfWeek
  const currentDay = date.day()
  let diff = currentDay - firstDayOfWeek

  // If the current day comes before the first day of week, we need to adjust
  if (diff < 0) diff += 7

  // Subtract the difference to get to the start of week
  return date.subtract(diff, 'day')
}

export function currentTimezonedTime(instance: number): Dayjs {
  const instanceDayjs = dayjs(instance)
  const instanceOffset = instanceDayjs.tz(getDefaultTimezone()).utcOffset()
  return instanceDayjs
    .tz(getDefaultTimezone())
    .subtract(instanceOffset, 'minute')
}
